/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ breakdown: NonNullable<unknown> }} System_Status_Summary_MultipleInputs */



/**
* | output |
* | --- |
* | "Active service notices — {breakdown}" |
*
* @param {System_Status_Summary_MultipleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_summary_multiple = /** @type {((inputs: System_Status_Summary_MultipleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Summary_MultipleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktive Servicehinweise – ${i?.breakdown}`)
	return /** @type {LocalizedString} */ (`Active service notices — ${i?.breakdown}`)
});